import { AnimatePresence, motion } from 'framer-motion'
import MD5 from 'md5'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { AiFillSafetyCertificate, AiOutlineExclamationCircle, AiTwotoneLock, AiTwotonePhone } from 'react-icons/ai'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { login } from '@/api/login'
import { uploadWork } from '@/api/room'
import { loginStore, useRecoilState, useRecoilValue, useSetRecoilState } from '@/store'
import { checkOS } from '@/utils/tool'

import Area from '../Area'
import Slider from '../Slider'
const { stepState, areaState, mobileState, needSliderState } = loginStore

export default function Index() {
  const setStep = useSetRecoilState(stepState)
  const [areaCode, setAreaCode] = useRecoilState(areaState)
  const [mobile, setMobile] = useRecoilState(mobileState)
  const [ncState, setNcState] = useState(false)
  const [mobileError, setMobileError] = useState('')
  const [input, setInput] = useState('')
  const [codeError, setCodeError] = useState('')
  const [errorMsg, setErrorMsg] = useState('')
  const needSlider = useRecoilValue(needSliderState)
  const navigate = useNavigate()

  const handleSubmit = useMutation(() => {
    return login({
      areaCode,
      mobile,
      type: 'PASSWORD',
      input: MD5(input),
      // 设备唯一标识 - 指纹
      uniqueDeviceNo: localStorage.visitorId,
      // 1:一键登录 2:验证码登录 3:密码登录 4:微信登录 5：多孩子切换登录
      loginType: 3,
      // 当前用户登录的IP地址
      Ip: '',
      // Web、pc客户端
      deviceId: 'Web',
      // 浏览器名称版本、pc客户端机型：mac、Windows
      model: checkOS(),
      // 版本号
      buildVersion: '',
      // 6->浏览器、7->pc端
      platform: 6,
      // 老师：0，学生：1
      identity: 1
    })
  })

  useEffect(() => {
    if (handleSubmit.status === 'error') {
      setErrorMsg('登录失败，请重试')
    }
    if (handleSubmit.data) {
      if (handleSubmit.data.status !== 0) {
        setErrorMsg(handleSubmit.data.msg)
        if (needSlider) {
          window.nc.reset()
          setNcState(false)
        }
      } else {
        if (handleSubmit.status === 'success') {
          const {
            data: { head, username, devices, uid, isVip, token = '', childs = null }
          } = handleSubmit.data
          const { result } = devices
          sessionStorage.upDateSign = 1
          localStorage.deviceTest = result ? 'true' : 'false'
          localStorage.setItem('head', head)
          localStorage.setItem('username', username)
          localStorage.setItem('devices', JSON.stringify(devices))
          localStorage.setItem('userid', uid)
          localStorage.setItem('token', token)
          localStorage.setItem('isVip', isVip ? 1 : 0)
          if (childs) {
            const findIdx = childs.findIndex((item) => String(item.id) === uid)
            if (findIdx !== -1) {
              localStorage.setItem('token', childs[findIdx].token)
            }
            // 存储多个账号信息
            localStorage.setItem('__myk_users__', JSON.stringify(childs))
          }
          navigate('/center')
        }
      }
    }
  }, [handleSubmit.status])

  const changeAreaCode = (e: string) => {
    setAreaCode(e)
    setMobile('')
    setMobileError('')
    setErrorMsg('')
  }

  const inputChange = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
    const val = e.target.value
    if (type === 'mobile') {
      setMobile(val)
    } else {
      setInput(val)
    }
  }

  useEffect(() => {
    if (areaCode === '+86' && mobile.length === 11) {
      if (/^1[3456789]\d{9}$/.test(mobile)) {
        setMobileError('success')
        setErrorMsg('')
      } else {
        // 验证手机号
        setMobileError('error')
        setErrorMsg('请输入正确的手机号')
      }
    } else if (areaCode !== '+86' && mobile.length >= 7) {
      setMobileError('success')
      setErrorMsg('')
    } else {
      setMobileError('')
      setErrorMsg('')
    }
  }, [mobile])

  useEffect(() => {
    if (input.length > 0) {
      setCodeError('success')
      setErrorMsg('')
    } else {
      setCodeError('')
      setErrorMsg('')
    }
  }, [input])

  const ncSign = () => {
    setErrorMsg('')
    setNcState(true)
  }

  return (
    <Container className="h-full w-full flex flex-col items-start justify-center">
      <div className="text-[24px] text-[#333]">密码登录</div>
      <div className="w-[350px] my-[30px]">
        <div className="w-full h-[40px] border-b border-[#ddd] flex items-center justify-center mb-[30px]">
          <div className="w-[40px] h-full flex items-center justify-center">
            <AiTwotonePhone className="text-[28px] text-[#999]" />
          </div>
          <Area onChange={changeAreaCode} areaCode={areaCode} />
          <div className="flex-1 h-full relative">
            <input
              value={mobile}
              onChange={(e) => inputChange(e, 'mobile')}
              className="absolute h-full w-full p-[10px] border-0 outline-none text-[20px] text-[#656565]"
              placeholder="请输入手机号码"
              maxLength={11}
            ></input>
          </div>
        </div>

        <div className="w-full h-[40px] border-b border-[#ddd] flex items-center justify-center mb-[30px]">
          <div className="w-[40px] h-full flex items-center justify-center">
            <AiTwotoneLock className="text-[28px] text-[#999]" />
          </div>
          <div className="flex-1 h-full relative">
            <input
              value={input}
              type="password"
              onChange={(e) => inputChange(e, 'input')}
              className="absolute h-full w-full p-[10px] border-0 focus:ring-transparent text-[20px] text-[#656565]"
              placeholder="请输入密码"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSubmit.mutate()
                }
              }}
            ></input>
          </div>
        </div>
        {needSlider ? (
          <div className="h-[34px]">
            <Slider ncSign={ncSign} />
          </div>
        ) : null}
      </div>
      {errorMsg ? (
        <div className="text-[#e82925] text-[14px] flex items-center mb-[20px]">
          <AiOutlineExclamationCircle className="mr-[5px]" />
          {errorMsg}
        </div>
      ) : null}
      <div className="w-[350px]">
        <div className="w-full mb-[20px] flex items-center justify-between">
          <div className="cursor-pointer text-[14px] text-[#333333]" onClick={() => setStep(0)}>
            验证码登录
          </div>
          <div className="cursor-pointer text-[14px] text-[#ff783a]" onClick={() => setStep(3)}>
            忘记密码
          </div>
        </div>
        <div className="w-full mb-[20px]">
          <button
            disabled={!(codeError === 'success' && mobileError === 'success' && ((needSlider && ncState) || !needSlider))}
            onClick={() => handleSubmit.mutate()}
            className={`btn-def w-[260px] h-[48px] rounded-full flex items-center justify-center outline-none text-[20px] text-[#FFF]
            ${codeError === 'success' && mobileError === 'success' && ((needSlider && ncState) || !needSlider) ? 'btn-active' : ''}
            `}
          >
            登录
          </button>
        </div>
        <div className="text-[14px] text-[#333333]">
          没有账号，
          <span className="cursor-pointer text-[#ff783a]" onClick={() => setStep(2)}>
            免费注册
          </span>
        </div>
      </div>
    </Container>
  )
}

const Container = styled(motion.div)`
  .btn-def {
    background: linear-gradient(270deg, #888, #ccc);
  }
  .btn-active {
    background: linear-gradient(90deg, #ff7839, #fe4844);
  }
`
